/**
 * Stamps `deploy_branch` (resolved from Netlify's `HEAD`/`BRANCH` in
 * webpack.config.ts) onto every Segment message:
 *   - `context.deploy_branch` on all message types (track/page/identify/
 *     group/alias/screen) — the idiomatic spot for build-time metadata.
 *   - `properties.deploy_branch` additionally on `track`/`page` so
 *     filters built against the top-level property keep working.
 */

// DefinePlugin inlines this as a string literal at build time (real
// branch on Netlify, "local" elsewhere), so the lookup is never undefined.
var DEPLOY_BRANCH = process.env.DEPLOY_BRANCH;
var middlewareRegistered = false;
var injectDeployBranch = function injectDeployBranch(payload, next) {
  var _payload$obj$type, _payload$obj;
  var obj = payload.obj || payload;
  var type = typeof payload.type === "function" ? payload.type() : (_payload$obj$type = (_payload$obj = payload.obj) === null || _payload$obj === void 0 ? void 0 : _payload$obj.type) !== null && _payload$obj$type !== void 0 ? _payload$obj$type : payload.type;
  var context = obj.context || {};
  context.deploy_branch = DEPLOY_BRANCH;
  obj.context = context;
  if (type === "track" || type === "page") {
    var properties = obj.properties || {};
    properties.deploy_branch = DEPLOY_BRANCH;
    obj.properties = properties;
  }
  next(payload);
};
export var registerDeployBranchMiddleware = function registerDeployBranchMiddleware() {
  if (typeof window === "undefined") return;
  if (middlewareRegistered) return;
  var analytics = window.analytics;
  if (!analytics) return;
  if (typeof analytics.addSourceMiddleware === "function") {
    analytics.addSourceMiddleware(function (_ref) {
      var payload = _ref.payload,
        next = _ref.next;
      return injectDeployBranch(payload, next);
    });
    middlewareRegistered = true;
    return;
  }
  if (typeof analytics.addMiddleware === "function") {
    analytics.addMiddleware(function (_ref2) {
      var payload = _ref2.payload,
        next = _ref2.next;
      return injectDeployBranch(payload, next);
    });
    middlewareRegistered = true;
  }
};